import type { Post } from "@/payload-types";
import { parseVideoUrl, generateEmbedUrl } from "@/utilities/video/parseVideoUrl";

/**
 * Resolve an iframe-embeddable URL from the post's videoEmbed field.
 * Returns null when the URL isn't recognized or the platform requires
 * script-based embedding (Instagram, TikTok) — those cases should fall
 * back to the raw `embedCode` HTML.
 */
export function getEmbedUrl(videoEmbed: NonNullable<Post["videoEmbed"]>): string | null {
    const { url } = videoEmbed;
    if (!url) return null;
    const parsed = parseVideoUrl(url);
    if (!parsed) return null;
    return generateEmbedUrl(parsed.platform, parsed.videoId);
}
